import { render } from "./rfp-iframe-main-container.vue?vue&type=template&id=d922cdbc"
import script from "./rfp-iframe-main-container.vue?vue&type=script&lang=js"
export * from "./rfp-iframe-main-container.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__